import { render, staticRenderFns } from "./summaryTask.vue?vue&type=template&id=f3871ed2&scoped=true&"
import script from "./summaryTask.vue?vue&type=script&lang=js&"
export * from "./summaryTask.vue?vue&type=script&lang=js&"
import style0 from "./summaryTask.vue?vue&type=style&index=0&id=f3871ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3871ed2",
  null
  
)

export default component.exports